import { Info } from "lucide-react";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useEffect } from "react";

import { useCustomParametersStore } from "./custom-parameters-store";
import { EmptyPreviewSidebar } from "./Placeholders/EmptyPreviewSidebar";

import { Parameter } from "@/components/ModelParameters/AdvancedParameters/ParameterControl";
import { ParameterStore } from "@/components/ModelParameters/store/parameter-store";
import { BasicTooltip } from "@/components/ui/Tooltip";

export const ParametersPreviewSidebar = observer(() => {
  const store = useCustomParametersStore();
  const { currentParameter } = store;

  const previewParameterStore = useLocalObservable(
    () => new ParameterStore(currentParameter?.getParameter || {}),
  );

  useEffect(() => {
    if (!currentParameter?.getParameter) {
      return;
    }

    previewParameterStore.updateParameter(currentParameter?.getParameter);
  }, [currentParameter?.getParameter, previewParameterStore]);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="mb-4 flex shrink-0 items-center gap-2">
        <h1 className="text-lg font-medium">Parameter Preview</h1>
        <BasicTooltip content="Interacting with the parameter will not update its settings.">
          <Info className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
        </BasicTooltip>
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center">
        {currentParameter ? (
          <div className="flex h-full w-full items-center justify-center rounded-md border border-gray-300 bg-gray-50 p-8 shadow-inner">
            <Parameter parameter={previewParameterStore} />
          </div>
        ) : (
          <EmptyPreviewSidebar />
        )}
      </div>
    </div>
  );
});
